import { useCallback } from 'react';
import { useShoppingCart } from '../context/ShoppingCartContext';
import { getSTCValues } from '../functions/getZoneAndStcValues';
import { useDebounce } from './useDebounce';

export const useSTCProcessing = () => {
  const { cartItems, setCartItems } = useShoppingCart();

  const processSTCForPostcode = useCallback((postcode: string, tradingStc: string) => {
    // Only process if postcode is valid (3 or 4 digits) and trading STC is enabled
    if (!/^\d{3,4}$/.test(postcode) || tradingStc !== '1') {
      // Remove any existing STC products if conditions are not met
      const filteredItems = cartItems.filter(item => item.stockcode !== 'WS-H-STC-ASSIGNED');
      if (filteredItems.length !== cartItems.length) {
        setCartItems(filteredItems);
      }
      return;
    }

    const stcEligibleProducts = [
      "H-PASHW015-270LD-R290",
      "H-PASHW008-180LD-R290"
    ];

    const eligibleItems = cartItems.filter(item =>
      stcEligibleProducts.includes(item.stockcode)
    );

    if (eligibleItems.length === 0) {
      // Remove existing STC products if no eligible items
      const filteredItems = cartItems.filter(item => item.stockcode !== 'WS-H-STC-ASSIGNED');
      if (filteredItems.length !== cartItems.length) {
        setCartItems(filteredItems);
      }
      return;
    }

    // Remove existing STC products before adding new ones
    let updatedCartItems = cartItems.filter(item => item.stockcode !== 'WS-H-STC-ASSIGNED');
    let stcProductId = 999;
    const stcProducts: any[] = [];

    eligibleItems.forEach(item => {
      const stcValues = getSTCValues(Number(postcode), item.stockcode);

      if (stcValues.quantity && stcValues.price && stcValues.zone) {
        const productSTCQuantity = stcValues.quantity * item.quantity;

        const stcProduct = {
          id: stcProductId++,
          stockcode: 'WS-H-STC-ASSIGNED',
          description: 'STCs assigned by 3rd Party HW W-S Customers',
          quantity: productSTCQuantity,
          price: -Math.abs(35) 
        };

        stcProducts.push(stcProduct);
      }
    });

    if (stcProducts.length > 0) {
      updatedCartItems = [...updatedCartItems, ...stcProducts];
      setCartItems(updatedCartItems);
    }
  }, [cartItems, setCartItems]);

  const debouncedProcessSTC = useDebounce(processSTCForPostcode, 500); // 500ms debounce

  return { processSTCForPostcode: debouncedProcessSTC };
};